/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Portal_Macro_CarbsInputs */

const en_portal_macro_carbs = /** @type {(inputs: Portal_Macro_CarbsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Carbs`)
};

const pl_portal_macro_carbs = /** @type {(inputs: Portal_Macro_CarbsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Węglowodany`)
};

/**
* | output |
* | --- |
* | "Carbs" |
*
* @param {Portal_Macro_CarbsInputs} inputs
* @param {{ locale?: "en" | "pl" }} options
* @returns {LocalizedString}
*/
export const portal_macro_carbs = /** @type {((inputs?: Portal_Macro_CarbsInputs, options?: { locale?: "en" | "pl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Portal_Macro_CarbsInputs, { locale?: "en" | "pl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pl") return pl_portal_macro_carbs(inputs)
	return en_portal_macro_carbs(inputs)
});